var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x2014_\\xCE\\xD3\\xC8_x5F_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,7L15.4.9c0-.8-1-1.2-1.5-.6l-5,5.4L5.1.8c0,0-.2-.1-.3-.1H.7c-.3,0-.4.3-.3.6l5.4,7.8L0,15.5c.6.6,1.6.5,2.1,0l4.7-5.1,4.2,5.5c0,0,.2.1.3.1h4.4c.3,0,.5-.3.3-.6l-6.1-8.4ZM13.1,14.5h-.9c0,0-.2,0-.2,0L3,3c-.1-.2,0-.4.2-.4h.9c0,0,.2,0,.2,0l9,11.5c.1.2,0,.4-.2.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon2);
export default __webpack_public_path__ + "static/media/nav-icon2.9c2f57181a362a2cccca8afa83895692.svg";
export { ForwardRef as ReactComponent };